import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {User} from '../../../../models/api/user.model';

@Component({
    selector: 'app-user-card',
    templateUrl: './user-card.component.html',
    styleUrls: ['./user-card.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class UserCardComponent {
    @Input() user: User;
}
